import React, { ChangeEvent, FunctionComponent, KeyboardEvent, useEffect, useRef } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { IconColor } from "../Icon";
import { IconButton } from "../IconButton";
import { JustifyContent, Layout } from "../Layout";

export type AdvancedFilterProps = {
    /** Podmínka, která má být zobrazena v komponentě */
    condition?: string;
    /** Callback volaný při stisku Enter */
    onConfirm: (condition: string) => void;
    /** Callback volaný po změně obsahu vstupního pole (po ztrátě focusu) */
    onChange: (condition: string) => void;
    /** Callback volaný při kliku na tlačítko zavřít */
    onClose: () => void;
};

const classNames = bemClassNames("advanced-filter-component");

export const AdvancedFilter: FunctionComponent<AdvancedFilterProps> = ({ condition, onConfirm, onChange, onClose }) => {
    const inputElement = useRef<HTMLTextAreaElement>(null);

    const onKeyPress = (event: KeyboardEvent) => {
        if (inputElement.current && event.charCode === 13 && !event.shiftKey) {
            onConfirm(inputElement.current.value);

            event.preventDefault();
        }
    };

    const changeEvent = (event: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(event.target.value);
    };

    useEffect(() => {
        if (inputElement.current) {
            inputElement.current.focus();
        }
    });

    return (
        <div
            className={classNames()}
        >
            <Layout
                justifyContent={JustifyContent.flexEnd}
            >
                <IconButton
                    iconCode={IconCode.uiCrossSmall}
                    onClick={onClose}
                    color={IconColor.grey1}
                />
            </Layout>
            <textarea
                className={classNames("input")}
                placeholder={"(name = 'text1' and \"Last Name\" = 'text2') or name = 'text3'"}
                ref={inputElement}
                onKeyPress={onKeyPress}
                defaultValue={condition}
                onChange={changeEvent}
            >
            </textarea>

        </div>
    );
};
